<button
  (click)="toggleSound()"
  mat-icon-button
  color="warn"
  aria-label="toggle sound button">
  <mat-icon class="title-yellow" *ngIf="soundBG">volume_up</mat-icon>
  <mat-icon class="title-yellow" *ngIf="!soundBG">volume_off</mat-icon>
</button>
